<template>
	<div
		:class="`relative -order-1 ${blok.imagePosition || ''} ${blok.imageHeight}`"
	>
		<NuxtImg
			:src="imageObject?.image?.filename"
			:alt="imageObject?.image?.alt || ''"
			class="w-full h-full object-cover absolute inset-0"
			provider="storyblok"
			v-bind="imagePriority"
			format="webp"
			sizes="sm:80vw md:70vw lg:80vw"
			:width="storyblokImgDimensions.width"
			:height="storyblokImgDimensions.height"
		/>
	</div>
	<div
		:class="`px-4 ${blok.isColumnDirection ? 'pt-4 pb-6 h-full' : 'py-6 lg:px-20 lg:py-0'} flex flex-col justify-center overflow-hidden ${blok.contentPosition || ''}`"
	>
		<h2
			v-if="blok.heading"
			class="hero-with-text__heading text-ellipsis overflow-hidden"
			:class="`${blok.titleSize || ''} ${blok.headingOrder || ''}`"
		>
			{{ blok.heading }}
		</h2>
		<p
			v-if="blok.subHeading"
			class="mb-2 font-semibold tracking-wider gray-600 uppercase"
			:class="`${blok.subHeadingSize || ''} ${blok.subHeadingOrder || ''}`"
		>
			{{ blok.subHeading }}
		</p>
		<p
			class="mt-2 mb-6"
			:class="`${blok.textSize || ''} ${blok.textOrder || ''}`"
		>
			{{ blok.text }}
		</p>
		<div
			class="order-last"
			:class="`${blok.buttonPosition || ''} ${alignButton ? 'mt-auto' : ''}`"
		>
			<button
				v-if="button"
				class="hero-with-text__button md:text-base text-sm group"
				:class="button.style"
			>
				{{ button.button_text }}
				<ArrowRightIcon
					v-if="button.style === 'button-arrow'"
					class="w-6 group-hover:translate-x-1/4 transition-all duration-200 ease-in-out"
				/>
			</button>
		</div>
	</div>
</template>

<script setup lang="ts">
// `hero-with-text__heading` and `hero-with-text__button` are styling hooks
// (styled in hogsta).
import type { BlokHeroWithText } from "~/types/storyblok/storyblok";
import { ArrowRightIcon } from "@heroicons/vue/24/outline";

interface Props {
	blok: BlokHeroWithText;
	alignButton?: boolean;
}
const { blok } = defineProps<Props>();
const imagePriority = useBlokImagePriority();

const storyblokImgDimensions = useStoryblokAssetDimensions(
	() => blok?.image?.[0]?.image?.filename
);
const imageObject = computed(() => blok?.image?.[0] || null);
const button = computed(() => blok.call_to_action?.[0] || null);
</script>
